import { AiFillCaretDown, AiFillCaretLeft, AiFillCaretRight, 
  AiFillCaretUp, AiFillCloseCircle, AiFillPlayCircle, AiFillSetting, 
  AiOutlineClockCircle, AiOutlineClose, AiOutlineForm, AiOutlineInfoCircle, AiOutlineLink, 
  AiOutlineMinusCircle, 
  AiOutlineNumber, AiOutlinePlusCircle, AiOutlineQuestion, AiOutlineSearch } from "react-icons/ai";
import { BiBuilding, BiSolidDashboard, BiSolidError, BiSolidUserCircle, BiText } from "react-icons/bi";
import { BsCalendar, BsFillStarFill, BsStar } from "react-icons/bs";
import { MdAdd, MdAddCircleOutline, MdAlternateEmail, MdBlock, MdBuild, MdCancel, MdCheck, MdChevronLeft, MdChevronRight, MdCleaningServices, MdComment, MdEdit, MdFilterAltOff, MdFilterList, MdKeyboardArrowDown, MdKeyboardArrowUp, MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight, MdListAlt, MdLocationPin, MdLogout, MdMeetingRoom, MdPhone, MdStream } from "react-icons/md";
import { TbLanguage, TbLock, TbLockExclamation, TbLockOpen2, TbNumber } from "react-icons/tb";
import { WiTime3 } from "react-icons/wi";
import { ColorX } from ".";
import { FaChevronDown, FaChevronLeft, FaChevronRight, FaChevronUp, FaCloudUploadAlt, FaKey, FaMapMarkedAlt, FaWpforms } from "react-icons/fa";
import { FaSignature, FaXmark } from "react-icons/fa6";
import { RiSettings3Fill } from "react-icons/ri";
import { GiElevator } from "react-icons/gi";
import { ImWarning } from "react-icons/im";
import { FiAlertCircle } from "react-icons/fi";

/**
 * 
 * @typedef { "ant" | "entypo" | "evil" | "feather" 
*  | "awesome" | "awesome5" | "fontisto"
*  | "foundation" | "ionic" | "mui" | "muicom" 
*  | "oct" | "zocial" | "simple" | "custom" } bundle
*/

/**
 * https://react-icons.github.io/react-icons/search?q=check
 * 
 * https://oblador.github.io/react-native-vector-icons/
 * @augments {Component<Props, State>}
 */
class IconX {

  static __Icons = {
    "awesome": {
      "calendar": (style) => <BsCalendar style={style}/>,
      "user-circle-o": (style) => <BiSolidUserCircle style={style}/>,
      "search": (style) => <AiOutlineSearch style={style}/>,
      "caret-left": (style) => <AiFillCaretLeft style={style}/>,
      "caret-right": (style) => <AiFillCaretRight style={style}/>,
      "wpforms": (style) => <FaWpforms style={style}/>,
      "signature": (style) => <FaSignature style={style}/>,
      "cloudupload": (style) => <FaCloudUploadAlt style={style}/>,
      "chevron-left": (style) => <FaChevronLeft style={style}/>,
      "chevron-right": (style) => <FaChevronRight style={style}/>,
      "chevron-up": (style) => <FaChevronUp style={style}/>,
      "chevron-down": (style) => <FaChevronDown style={style}/>,
      "xmark": (style) => <FaXmark style={style}/>
    },
    "awesome5": {
      "key": (style) => <FaKey style={style}/>
    },
    "entypo": {
      "email": (style) => <MdAlternateEmail style={style}/>,
      "phone": (style) => <MdPhone style={style}/>,
      "location-pin": (style) => <MdLocationPin style={style}/>,
      "location": (style) => <FaMapMarkedAlt style={style}/>
    },
    "mui": {
      "add-circle-outline": (style) => <MdAddCircleOutline style={style}/>,
      "meeting-room": (style) => <MdMeetingRoom style={style}/>,
      "elevator": (style) => <GiElevator style={style}/>,
      "stream": (style) => <MdStream style={style}/>,
      "block": (style) => <MdBlock style={style}/>,
      "cleaning-services": (style) => <MdCleaningServices style={style}/>,
      "cancel": (style) => <MdCancel style={style}/>,
      "error-outline": (style) => <BiSolidError style={style}/>,
      "chevron-left": (style) => <MdChevronLeft style={style}/>,
      "chevron-right": (style) => <MdChevronRight style={style}/>,
      "keyboarddoubleleft": (style) => <MdKeyboardDoubleArrowLeft style={style}/>,
      "keyboarddoubleright": (style) => <MdKeyboardDoubleArrowRight style={style}/>,
      "logout": (style) => <MdLogout style={style}/>,
      "keyboard-arrow-up": (style) => <MdKeyboardArrowUp style={style}/>,
      "keyboard-arrow-down": (style) => <MdKeyboardArrowDown style={style}/>,
      "build": (style) => <MdBuild style={style}/>,
      "comment": (style) => <MdComment style={style}/>,
      "edit": (style) => <MdEdit style={style}/>,
    },
    "muicom": {
      "filter-off": (style) => <MdFilterAltOff style={style}/>,
      "identifier": (style) => <TbNumber style={style}/>,
      "clock-time-nine-outline": (style) => <AiOutlineClockCircle style={style}/>,
      "office-building": (style) => <BiBuilding style={style}/>,
      "view-dashboard": (style) => <BiSolidDashboard style={style}/>,
      "close-circle": (style) => <AiFillCloseCircle style={style}/>,
      "lock": (style) => <TbLock style={style}/>,
      "unlock": (style) => <TbLockOpen2 style={style}/>,
      "lock-alert": (style) => <TbLockExclamation style={style}/>,
    },
    "ant": {
      "form": (style) => <AiOutlineForm style={style}/>,
      "caretup": (style) => <AiFillCaretUp style={style}/>,
      "caretdown": (style) => <AiFillCaretDown style={style}/>,
      "caretleft": (style) => <AiFillCaretLeft style={style}/>,
      "caretright": (style) => <AiFillCaretRight style={style}/>,
      "playcircleo": (style) => <AiFillPlayCircle style={style}/>,
      "link": (style) => <AiOutlineLink style={style}/>,
      "close": (style) => <AiOutlineClose style={style}/>,
      "star": (style) => <BsFillStarFill style={style}/>,
      "staro": (style) => <BsStar style={style}/>,
      "questioncircleo": (style) => <AiOutlineQuestion style={style}/>,
      "infocirlceo": (style) => <AiOutlineInfoCircle style={style}/>
    },
    "ionic": {
      "time-outline":  (style) => <WiTime3 style={style}/>,
      "filter":  (style) => <MdFilterList style={style}/>,
      "language": (style) => <TbLanguage style={style}/>,
      "text": (style) => <BiText style={style}/>,
      "settings-sharp": (style) => <RiSettings3Fill style={style}/>,
      "settings": (style) => <AiFillSetting style={style}/>,
      "add":  (style) => <MdAdd style={style}/>,
      "warning": (style) => <ImWarning style={style}/>
    },
    "feather": {
      "info": (style) => <FiAlertCircle style={style}/>,
      "list": (style) => <MdListAlt style={style}/>,
      "check": (style) => <MdCheck style={style}/>,
      "plus-circle": (style) => <AiOutlinePlusCircle style={style}/>,
      "minus-circle": (style) => <AiOutlineMinusCircle style={style}/>
    },
    "oct": {
      "number": (style) => <AiOutlineNumber style={style}/>
    },

  }

  /**
   * 
   * @param {bundle} bundle 
   * @param {String} name 
   * @param {Number} size 
   * @param {*} color 
   * @param {*} style
   */
  static Get(bundle, name, size, color, style = {}){
    let icon = this.__Icons?.[bundle]?.[name] ?? null;
    if(!icon){
      console.log(`%cIconX :: (${bundle},${name}) is not set.`,  
          "color: " + ColorX.CSS("orange"));
    }
    let _style = {
      width: size, height: size, fontSize: size, color: color, 
      alignItems: "center",
      justifyContent: "center",
      ...style
    };
    return icon?.(_style) ?? null;
  }

}

export default IconX;